<p-fieldset [legend]="'COMMON.IMPERSONATE' | translate">
    <div class="col-12">{{'COMMON.SELECT_IMPER_USER' | translate}}</div>
    <div class="col-12" *ngIf="!usersLoaded">
        <div class="col-12 spinner-container"><p-progressSpinner [style]="{width: '50px', height: '50px'}"></p-progressSpinner></div>
        <div class="col-12">{{'COMMON.LOADING_USER_LIST' | translate}}</div>
    </div>
    <div class="col-12">
        <div class="col-12" *ngIf="usersLoaded">
            <p-dropdown [options]="customerGroupsAndUsers" [(ngModel)]="impersonationSubject" placeholder=""
                        [group]="true" [filter]="true" [style]="{'width':'100%'}">
                <ng-template let-group pTemplate="group">
                    <span class="group-label">{{'COMMON.GROUP' |translate}} : {{group.label}}</span>
                </ng-template>
            </p-dropdown>
        </div>
        <div class="col-12">
            <div class="col-8"></div>
            <div class="col-4">
                <button pButton type="button" [icon]="'fa fa-user-secret'" [label]="'COMMON.VALIDATE' | translate"
                        [iconPos]="'left'" id="impersonateAction"
                        (click)="impersonate()" [disabled]="!impersonationSubject"
                        class="p-button-warning"></button>
            </div>
        </div>
    </div>
</p-fieldset>
